/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as AuthRouteRouteImport } from './../routes/_auth/route'
import { Route as AuthIndexRouteImport } from './../routes/_auth/index'
import { Route as LoginOrganizationBusyRouteImport } from './../routes/login.organization-busy'
import { Route as LoginLicenseLimitRouteImport } from './../routes/login.license-limit'
import { Route as LoginInactiveRouteImport } from './../routes/login.inactive'
import { Route as LoginResumeRouteImport } from './../routes/_login/resume'
import { Route as LoginLoginRouteImport } from './../routes/_login/login'
import { Route as LoginContinueLogoutRouteImport } from './../routes/_login/continue-logout'
import { Route as LegacyHomeRouteImport } from './../routes/_legacy/home'
import { Route as LegacyDashboardsRouteImport } from './../routes/_legacy/dashboards'
import { Route as LegacyCreateRouteImport } from './../routes/_legacy/create'
import { Route as AuthReportsRouteImport } from './../routes/_auth/reports'
import { Route as AuthProfileRouteImport } from './../routes/_auth/profile'
import { Route as AuthHostRouteImport } from './../routes/_auth/host'
import { Route as AuthGridRouteImport } from './../routes/_auth/grid'
import { Route as AuthDesignerRouteImport } from './../routes/_auth/designer'
import { Route as AuthComponentsRouteImport } from './../routes/_auth/components'
import { Route as AuthCardRouteImport } from './../routes/_auth/card'
import { Route as AuthCalcstatusRouteImport } from './../routes/_auth/calcstatus'
import { Route as Auth404RouteImport } from './../routes/_auth/404'
import { Route as Auth403RouteImport } from './../routes/_auth/403'
import { Route as AuthTerminalConnectRouteRouteImport } from './../routes/_auth/terminal-connect/route'
import { Route as AuthPreferencesRouteRouteImport } from './../routes/_auth/preferences/route'
import { Route as AuthTerminalConnectIndexRouteImport } from './../routes/_auth/terminal-connect/index'
import { Route as AuthPreferencesIndexRouteImport } from './../routes/_auth/preferences/index'
import { Route as LegacyEntitiesSplatRouteImport } from './../routes/_legacy/entities.$'
import { Route as AuthTerminalConnectEmbedRouteImport } from './../routes/_auth/terminal-connect/embed'
import { Route as AuthPreferencesTeamsRouteImport } from './../routes/_auth/preferences/teams'
import { Route as AuthPreferencesSummaryDashboardSettingsRouteImport } from './../routes/_auth/preferences/summary-dashboard-settings'
import { Route as AuthPreferencesSummaryDashboardRouteImport } from './../routes/_auth/preferences/summary-dashboard'
import { Route as AuthPreferencesRecycleRouteImport } from './../routes/_auth/preferences/recycle'
import { Route as AuthPreferencesOrganizationRouteImport } from './../routes/_auth/preferences/organization'
import { Route as AuthPreferencesOauthAdminRouteImport } from './../routes/_auth/preferences/oauthAdmin'
import { Route as AuthPreferencesModelSettingRouteImport } from './../routes/_auth/preferences/modelSetting'
import { Route as AuthPreferencesModelRouteImport } from './../routes/_auth/preferences/model'
import { Route as AuthPreferencesMenuDesignerRouteImport } from './../routes/_auth/preferences/menu-designer'
import { Route as AuthPreferencesManagementRouteImport } from './../routes/_auth/preferences/management'
import { Route as AuthPreferencesInsightsDashboardRouteImport } from './../routes/_auth/preferences/insights-dashboard'
import { Route as AuthPreferencesHomepageDashboardRouteImport } from './../routes/_auth/preferences/homepage-dashboard'
import { Route as AuthPreferencesGroupsRouteImport } from './../routes/_auth/preferences/groups'
import { Route as AuthPreferencesGlobalTablesRouteImport } from './../routes/_auth/preferences/globalTables'
import { Route as AuthPreferencesFieldPermissionsRouteImport } from './../routes/_auth/preferences/fieldPermissions'
import { Route as AuthPreferencesDocumentsRouteImport } from './../routes/_auth/preferences/documents'
import { Route as AuthPreferencesDatasheetsRouteImport } from './../routes/_auth/preferences/datasheets'
import { Route as AuthPreferencesConditionalRouteImport } from './../routes/_auth/preferences/conditional'
import { Route as AuthIntegrationsSplatRouteImport } from './../routes/_auth/integrations.$'
import { Route as AuthInsightsReportsRouteImport } from './../routes/_auth/insights/reports'
import { Route as AuthInsightsDashboardsRouteImport } from './../routes/_auth/insights/dashboards'
import { Route as AuthInsightsDashboardIdRouteImport } from './../routes/_auth/insights/$dashboardId'
import { Route as AuthEntityNewRouteImport } from './../routes/_auth/entity/new'
import { Route as AuthCardFilterRouteImport } from './../routes/_auth/card.filter'
import { Route as AuthPreferencesUsersRouteRouteImport } from './../routes/_auth/preferences/users/route'
import { Route as AuthPreferencesRolesRouteRouteImport } from './../routes/_auth/preferences/roles/route'
import { Route as AuthPreferencesNavigationBarRouteRouteImport } from './../routes/_auth/preferences/navigation-bar/route'
import { Route as AuthPreferencesEntityTypesRouteRouteImport } from './../routes/_auth/preferences/entityTypes/route'
import { Route as AuthPreferencesDashboardsRouteRouteImport } from './../routes/_auth/preferences/dashboards/route'
import { Route as AuthEntityEntityIdRouteRouteImport } from './../routes/_auth/entity/$entityId/route'
import { Route as AuthPreferencesUsersIndexRouteImport } from './../routes/_auth/preferences/users/index'
import { Route as AuthPreferencesRolesIndexRouteImport } from './../routes/_auth/preferences/roles/index'
import { Route as AuthPreferencesNavigationBarIndexRouteImport } from './../routes/_auth/preferences/navigation-bar/index'
import { Route as AuthPreferencesEntityTypesIndexRouteImport } from './../routes/_auth/preferences/entityTypes/index'
import { Route as AuthPreferencesDashboardsIndexRouteImport } from './../routes/_auth/preferences/dashboards/index'
import { Route as AuthEntityEntityIdIndexRouteImport } from './../routes/_auth/entity/$entityId/index'
import { Route as AuthPreferencesUsersNewRouteImport } from './../routes/_auth/preferences/users/new'
import { Route as AuthPreferencesUsersUserIdRouteImport } from './../routes/_auth/preferences/users/$userId'
import { Route as AuthPreferencesNavigationBarOrgLogoRouteImport } from './../routes/_auth/preferences/navigation-bar/org-logo'
import { Route as AuthPreferencesDashboardsNewRouteImport } from './../routes/_auth/preferences/dashboards/new'
import { Route as AuthPreferencesDashboardsDashboardIdRouteImport } from './../routes/_auth/preferences/dashboards/$dashboardId'
import { Route as AuthPreferencesRolesRoleIdRouteRouteImport } from './../routes/_auth/preferences/roles/$roleId/route'
import { Route as AuthPreferencesEntityTypesEntityTypeIdRouteRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/route'
import { Route as AuthEntityEntityIdBreadcrumbsRouteRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/route'
import { Route as AuthPreferencesRolesRoleIdIndexRouteImport } from './../routes/_auth/preferences/roles/$roleId/index'
import { Route as AuthPreferencesEntityTypesEntityTypeIdIndexRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/index'
import { Route as AuthPreferencesRolesRoleIdEditRouteImport } from './../routes/_auth/preferences/roles/$roleId/edit'
import { Route as AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
import { Route as AuthPreferencesEntityTypesEntityTypeIdStagesRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/stages'
import { Route as AuthPreferencesEntityTypesEntityTypeIdRecurrencesRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/recurrences'
import { Route as AuthPreferencesEntityTypesEntityTypeIdFieldsRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/fields'
import { Route as AuthEntityEntityIdBreadcrumbsSummaryRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/summary'
import { Route as AuthEntityEntityIdBreadcrumbsRelationshipsRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/relationships'
import { Route as AuthEntityEntityIdBreadcrumbsNotesRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/notes'
import { Route as AuthEntityEntityIdBreadcrumbsModelsRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/models'
import { Route as AuthEntityEntityIdBreadcrumbsLinksRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/links'
import { Route as AuthEntityEntityIdBreadcrumbsExplorationRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/exploration'
import { Route as AuthEntityEntityIdBreadcrumbsDetailsRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/details'
import { Route as AuthEntityEntityIdBreadcrumbsCalculationLogRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/calculationLog'
import { Route as AuthEntityEntityIdBreadcrumbsSubEntityCodeRouteImport } from './../routes/_auth/entity/$entityId/_breadcrumbs/$subEntityCode'
import { Route as AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/rules/route'
import { Route as AuthPreferencesEntityTypesEntityTypeIdRulesNewRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/rules/new'
import { Route as AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRouteImport } from './../routes/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId'
import { Route as AuthEmbeddedDashboardAdminPowerbiReportIdRouteImport } from './../routes/_auth/embedded.dashboard.admin.powerbi.$reportId'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const LoginOrganizationBusyRoute = LoginOrganizationBusyRouteImport.update({
  id: '/login/organization-busy',
  path: '/login/organization-busy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLicenseLimitRoute = LoginLicenseLimitRouteImport.update({
  id: '/login/license-limit',
  path: '/login/license-limit',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginInactiveRoute = LoginInactiveRouteImport.update({
  id: '/login/inactive',
  path: '/login/inactive',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginResumeRoute = LoginResumeRouteImport.update({
  id: '/_login/resume',
  path: '/resume',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLoginRoute = LoginLoginRouteImport.update({
  id: '/_login/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginContinueLogoutRoute = LoginContinueLogoutRouteImport.update({
  id: '/_login/continue-logout',
  path: '/continue-logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LegacyHomeRoute = LegacyHomeRouteImport.update({
  id: '/_legacy/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const LegacyDashboardsRoute = LegacyDashboardsRouteImport.update({
  id: '/_legacy/dashboards',
  path: '/dashboards',
  getParentRoute: () => rootRouteImport,
} as any)
const LegacyCreateRoute = LegacyCreateRouteImport.update({
  id: '/_legacy/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthReportsRoute = AuthReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthHostRoute = AuthHostRouteImport.update({
  id: '/host',
  path: '/host',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthGridRoute = AuthGridRouteImport.update({
  id: '/grid',
  path: '/grid',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDesignerRoute = AuthDesignerRouteImport.update({
  id: '/designer',
  path: '/designer',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthComponentsRoute = AuthComponentsRouteImport.update({
  id: '/components',
  path: '/components',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCardRoute = AuthCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCalcstatusRoute = AuthCalcstatusRouteImport.update({
  id: '/calcstatus',
  path: '/calcstatus',
  getParentRoute: () => AuthRouteRoute,
} as any)
const Auth404Route = Auth404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => AuthRouteRoute,
} as any)
const Auth403Route = Auth403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTerminalConnectRouteRoute =
  AuthTerminalConnectRouteRouteImport.update({
    id: '/terminal-connect',
    path: '/terminal-connect',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthPreferencesRouteRoute = AuthPreferencesRouteRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTerminalConnectIndexRoute =
  AuthTerminalConnectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthTerminalConnectRouteRoute,
  } as any)
const AuthPreferencesIndexRoute = AuthPreferencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPreferencesRouteRoute,
} as any)
const LegacyEntitiesSplatRoute = LegacyEntitiesSplatRouteImport.update({
  id: '/_legacy/entities/$',
  path: '/entities/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTerminalConnectEmbedRoute =
  AuthTerminalConnectEmbedRouteImport.update({
    id: '/embed',
    path: '/embed',
    getParentRoute: () => AuthTerminalConnectRouteRoute,
  } as any)
const AuthPreferencesTeamsRoute = AuthPreferencesTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthPreferencesRouteRoute,
} as any)
const AuthPreferencesSummaryDashboardSettingsRoute =
  AuthPreferencesSummaryDashboardSettingsRouteImport.update({
    id: '/summary-dashboard-settings',
    path: '/summary-dashboard-settings',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesSummaryDashboardRoute =
  AuthPreferencesSummaryDashboardRouteImport.update({
    id: '/summary-dashboard',
    path: '/summary-dashboard',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesRecycleRoute = AuthPreferencesRecycleRouteImport.update({
  id: '/recycle',
  path: '/recycle',
  getParentRoute: () => AuthPreferencesRouteRoute,
} as any)
const AuthPreferencesOrganizationRoute =
  AuthPreferencesOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesOauthAdminRoute =
  AuthPreferencesOauthAdminRouteImport.update({
    id: '/oauthAdmin',
    path: '/oauthAdmin',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesModelSettingRoute =
  AuthPreferencesModelSettingRouteImport.update({
    id: '/modelSetting',
    path: '/modelSetting',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesModelRoute = AuthPreferencesModelRouteImport.update({
  id: '/model',
  path: '/model',
  getParentRoute: () => AuthPreferencesRouteRoute,
} as any)
const AuthPreferencesMenuDesignerRoute =
  AuthPreferencesMenuDesignerRouteImport.update({
    id: '/menu-designer',
    path: '/menu-designer',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesManagementRoute =
  AuthPreferencesManagementRouteImport.update({
    id: '/management',
    path: '/management',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesInsightsDashboardRoute =
  AuthPreferencesInsightsDashboardRouteImport.update({
    id: '/insights-dashboard',
    path: '/insights-dashboard',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesHomepageDashboardRoute =
  AuthPreferencesHomepageDashboardRouteImport.update({
    id: '/homepage-dashboard',
    path: '/homepage-dashboard',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesGroupsRoute = AuthPreferencesGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthPreferencesRouteRoute,
} as any)
const AuthPreferencesGlobalTablesRoute =
  AuthPreferencesGlobalTablesRouteImport.update({
    id: '/globalTables',
    path: '/globalTables',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesFieldPermissionsRoute =
  AuthPreferencesFieldPermissionsRouteImport.update({
    id: '/fieldPermissions',
    path: '/fieldPermissions',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesDocumentsRoute =
  AuthPreferencesDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesDatasheetsRoute =
  AuthPreferencesDatasheetsRouteImport.update({
    id: '/datasheets',
    path: '/datasheets',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesConditionalRoute =
  AuthPreferencesConditionalRouteImport.update({
    id: '/conditional',
    path: '/conditional',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthIntegrationsSplatRoute = AuthIntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthInsightsReportsRoute = AuthInsightsReportsRouteImport.update({
  id: '/insights/reports',
  path: '/insights/reports',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthInsightsDashboardsRoute = AuthInsightsDashboardsRouteImport.update({
  id: '/insights/dashboards',
  path: '/insights/dashboards',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthInsightsDashboardIdRoute = AuthInsightsDashboardIdRouteImport.update({
  id: '/insights/$dashboardId',
  path: '/insights/$dashboardId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthEntityNewRoute = AuthEntityNewRouteImport.update({
  id: '/entity/new',
  path: '/entity/new',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCardFilterRoute = AuthCardFilterRouteImport.update({
  id: '/filter',
  path: '/filter',
  getParentRoute: () => AuthCardRoute,
} as any)
const AuthPreferencesUsersRouteRoute =
  AuthPreferencesUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesRolesRouteRoute =
  AuthPreferencesRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesNavigationBarRouteRoute =
  AuthPreferencesNavigationBarRouteRouteImport.update({
    id: '/navigation-bar',
    path: '/navigation-bar',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesEntityTypesRouteRoute =
  AuthPreferencesEntityTypesRouteRouteImport.update({
    id: '/entityTypes',
    path: '/entityTypes',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthPreferencesDashboardsRouteRoute =
  AuthPreferencesDashboardsRouteRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => AuthPreferencesRouteRoute,
  } as any)
const AuthEntityEntityIdRouteRoute = AuthEntityEntityIdRouteRouteImport.update({
  id: '/entity/$entityId',
  path: '/entity/$entityId',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPreferencesUsersIndexRoute =
  AuthPreferencesUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesUsersRouteRoute,
  } as any)
const AuthPreferencesRolesIndexRoute =
  AuthPreferencesRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesRolesRouteRoute,
  } as any)
const AuthPreferencesNavigationBarIndexRoute =
  AuthPreferencesNavigationBarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesNavigationBarRouteRoute,
  } as any)
const AuthPreferencesEntityTypesIndexRoute =
  AuthPreferencesEntityTypesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesEntityTypesRouteRoute,
  } as any)
const AuthPreferencesDashboardsIndexRoute =
  AuthPreferencesDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesDashboardsRouteRoute,
  } as any)
const AuthEntityEntityIdIndexRoute = AuthEntityEntityIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEntityEntityIdRouteRoute,
} as any)
const AuthPreferencesUsersNewRoute = AuthPreferencesUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthPreferencesUsersRouteRoute,
} as any)
const AuthPreferencesUsersUserIdRoute =
  AuthPreferencesUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AuthPreferencesUsersRouteRoute,
  } as any)
const AuthPreferencesNavigationBarOrgLogoRoute =
  AuthPreferencesNavigationBarOrgLogoRouteImport.update({
    id: '/org-logo',
    path: '/org-logo',
    getParentRoute: () => AuthPreferencesNavigationBarRouteRoute,
  } as any)
const AuthPreferencesDashboardsNewRoute =
  AuthPreferencesDashboardsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthPreferencesDashboardsRouteRoute,
  } as any)
const AuthPreferencesDashboardsDashboardIdRoute =
  AuthPreferencesDashboardsDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => AuthPreferencesDashboardsRouteRoute,
  } as any)
const AuthPreferencesRolesRoleIdRouteRoute =
  AuthPreferencesRolesRoleIdRouteRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AuthPreferencesRolesRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdRouteRoute =
  AuthPreferencesEntityTypesEntityTypeIdRouteRouteImport.update({
    id: '/$entityTypeId',
    path: '/$entityTypeId',
    getParentRoute: () => AuthPreferencesEntityTypesRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsRouteRoute =
  AuthEntityEntityIdBreadcrumbsRouteRouteImport.update({
    id: '/_breadcrumbs',
    getParentRoute: () => AuthEntityEntityIdRouteRoute,
  } as any)
const AuthPreferencesRolesRoleIdIndexRoute =
  AuthPreferencesRolesRoleIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesRolesRoleIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdIndexRoute =
  AuthPreferencesEntityTypesEntityTypeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthPreferencesRolesRoleIdEditRoute =
  AuthPreferencesRolesRoleIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthPreferencesRolesRoleIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute =
  AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRouteImport.update({
    id: '/timeSeriesSubEntity',
    path: '/timeSeriesSubEntity',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdStagesRoute =
  AuthPreferencesEntityTypesEntityTypeIdStagesRouteImport.update({
    id: '/stages',
    path: '/stages',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute =
  AuthPreferencesEntityTypesEntityTypeIdRecurrencesRouteImport.update({
    id: '/recurrences',
    path: '/recurrences',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdFieldsRoute =
  AuthPreferencesEntityTypesEntityTypeIdFieldsRouteImport.update({
    id: '/fields',
    path: '/fields',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsSummaryRoute =
  AuthEntityEntityIdBreadcrumbsSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsRelationshipsRoute =
  AuthEntityEntityIdBreadcrumbsRelationshipsRouteImport.update({
    id: '/relationships',
    path: '/relationships',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsNotesRoute =
  AuthEntityEntityIdBreadcrumbsNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsModelsRoute =
  AuthEntityEntityIdBreadcrumbsModelsRouteImport.update({
    id: '/models',
    path: '/models',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsLinksRoute =
  AuthEntityEntityIdBreadcrumbsLinksRouteImport.update({
    id: '/links',
    path: '/links',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsExplorationRoute =
  AuthEntityEntityIdBreadcrumbsExplorationRouteImport.update({
    id: '/exploration',
    path: '/exploration',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsDetailsRoute =
  AuthEntityEntityIdBreadcrumbsDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsCalculationLogRoute =
  AuthEntityEntityIdBreadcrumbsCalculationLogRouteImport.update({
    id: '/calculationLog',
    path: '/calculationLog',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute =
  AuthEntityEntityIdBreadcrumbsSubEntityCodeRouteImport.update({
    id: '/$subEntityCode',
    path: '/$subEntityCode',
    getParentRoute: () => AuthEntityEntityIdBreadcrumbsRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute =
  AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute =
  AuthPreferencesEntityTypesEntityTypeIdRulesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute,
  } as any)
const AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute =
  AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRouteImport.update({
    id: '/$ruleId',
    path: '/$ruleId',
    getParentRoute: () => AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute,
  } as any)
const AuthEmbeddedDashboardAdminPowerbiReportIdRoute =
  AuthEmbeddedDashboardAdminPowerbiReportIdRouteImport.update({
    id: '/embedded/dashboard/admin/powerbi/$reportId',
    path: '/embedded/dashboard/admin/powerbi/$reportId',
    getParentRoute: () => AuthRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/preferences': typeof AuthPreferencesRouteRouteWithChildren
  '/terminal-connect': typeof AuthTerminalConnectRouteRouteWithChildren
  '/403': typeof Auth403Route
  '/404': typeof Auth404Route
  '/calcstatus': typeof AuthCalcstatusRoute
  '/card': typeof AuthCardRouteWithChildren
  '/components': typeof AuthComponentsRoute
  '/designer': typeof AuthDesignerRoute
  '/grid': typeof AuthGridRoute
  '/host': typeof AuthHostRoute
  '/profile': typeof AuthProfileRoute
  '/reports': typeof AuthReportsRoute
  '/create': typeof LegacyCreateRoute
  '/dashboards': typeof LegacyDashboardsRoute
  '/home': typeof LegacyHomeRoute
  '/continue-logout': typeof LoginContinueLogoutRoute
  '/login': typeof LoginLoginRoute
  '/resume': typeof LoginResumeRoute
  '/login/inactive': typeof LoginInactiveRoute
  '/login/license-limit': typeof LoginLicenseLimitRoute
  '/login/organization-busy': typeof LoginOrganizationBusyRoute
  '/entity/$entityId': typeof AuthEntityEntityIdBreadcrumbsRouteRouteWithChildren
  '/preferences/dashboards': typeof AuthPreferencesDashboardsRouteRouteWithChildren
  '/preferences/entityTypes': typeof AuthPreferencesEntityTypesRouteRouteWithChildren
  '/preferences/navigation-bar': typeof AuthPreferencesNavigationBarRouteRouteWithChildren
  '/preferences/roles': typeof AuthPreferencesRolesRouteRouteWithChildren
  '/preferences/users': typeof AuthPreferencesUsersRouteRouteWithChildren
  '/card/filter': typeof AuthCardFilterRoute
  '/entity/new': typeof AuthEntityNewRoute
  '/insights/$dashboardId': typeof AuthInsightsDashboardIdRoute
  '/insights/dashboards': typeof AuthInsightsDashboardsRoute
  '/insights/reports': typeof AuthInsightsReportsRoute
  '/integrations/$': typeof AuthIntegrationsSplatRoute
  '/preferences/conditional': typeof AuthPreferencesConditionalRoute
  '/preferences/datasheets': typeof AuthPreferencesDatasheetsRoute
  '/preferences/documents': typeof AuthPreferencesDocumentsRoute
  '/preferences/fieldPermissions': typeof AuthPreferencesFieldPermissionsRoute
  '/preferences/globalTables': typeof AuthPreferencesGlobalTablesRoute
  '/preferences/groups': typeof AuthPreferencesGroupsRoute
  '/preferences/homepage-dashboard': typeof AuthPreferencesHomepageDashboardRoute
  '/preferences/insights-dashboard': typeof AuthPreferencesInsightsDashboardRoute
  '/preferences/management': typeof AuthPreferencesManagementRoute
  '/preferences/menu-designer': typeof AuthPreferencesMenuDesignerRoute
  '/preferences/model': typeof AuthPreferencesModelRoute
  '/preferences/modelSetting': typeof AuthPreferencesModelSettingRoute
  '/preferences/oauthAdmin': typeof AuthPreferencesOauthAdminRoute
  '/preferences/organization': typeof AuthPreferencesOrganizationRoute
  '/preferences/recycle': typeof AuthPreferencesRecycleRoute
  '/preferences/summary-dashboard': typeof AuthPreferencesSummaryDashboardRoute
  '/preferences/summary-dashboard-settings': typeof AuthPreferencesSummaryDashboardSettingsRoute
  '/preferences/teams': typeof AuthPreferencesTeamsRoute
  '/terminal-connect/embed': typeof AuthTerminalConnectEmbedRoute
  '/entities/$': typeof LegacyEntitiesSplatRoute
  '/preferences/': typeof AuthPreferencesIndexRoute
  '/terminal-connect/': typeof AuthTerminalConnectIndexRoute
  '/preferences/entityTypes/$entityTypeId': typeof AuthPreferencesEntityTypesEntityTypeIdRouteRouteWithChildren
  '/preferences/roles/$roleId': typeof AuthPreferencesRolesRoleIdRouteRouteWithChildren
  '/preferences/dashboards/$dashboardId': typeof AuthPreferencesDashboardsDashboardIdRoute
  '/preferences/dashboards/new': typeof AuthPreferencesDashboardsNewRoute
  '/preferences/navigation-bar/org-logo': typeof AuthPreferencesNavigationBarOrgLogoRoute
  '/preferences/users/$userId': typeof AuthPreferencesUsersUserIdRoute
  '/preferences/users/new': typeof AuthPreferencesUsersNewRoute
  '/entity/$entityId/': typeof AuthEntityEntityIdIndexRoute
  '/preferences/dashboards/': typeof AuthPreferencesDashboardsIndexRoute
  '/preferences/entityTypes/': typeof AuthPreferencesEntityTypesIndexRoute
  '/preferences/navigation-bar/': typeof AuthPreferencesNavigationBarIndexRoute
  '/preferences/roles/': typeof AuthPreferencesRolesIndexRoute
  '/preferences/users/': typeof AuthPreferencesUsersIndexRoute
  '/preferences/entityTypes/$entityTypeId/rules': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren
  '/entity/$entityId/$subEntityCode': typeof AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute
  '/entity/$entityId/calculationLog': typeof AuthEntityEntityIdBreadcrumbsCalculationLogRoute
  '/entity/$entityId/details': typeof AuthEntityEntityIdBreadcrumbsDetailsRoute
  '/entity/$entityId/exploration': typeof AuthEntityEntityIdBreadcrumbsExplorationRoute
  '/entity/$entityId/links': typeof AuthEntityEntityIdBreadcrumbsLinksRoute
  '/entity/$entityId/models': typeof AuthEntityEntityIdBreadcrumbsModelsRoute
  '/entity/$entityId/notes': typeof AuthEntityEntityIdBreadcrumbsNotesRoute
  '/entity/$entityId/relationships': typeof AuthEntityEntityIdBreadcrumbsRelationshipsRoute
  '/entity/$entityId/summary': typeof AuthEntityEntityIdBreadcrumbsSummaryRoute
  '/preferences/entityTypes/$entityTypeId/fields': typeof AuthPreferencesEntityTypesEntityTypeIdFieldsRoute
  '/preferences/entityTypes/$entityTypeId/recurrences': typeof AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute
  '/preferences/entityTypes/$entityTypeId/stages': typeof AuthPreferencesEntityTypesEntityTypeIdStagesRoute
  '/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity': typeof AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute
  '/preferences/roles/$roleId/edit': typeof AuthPreferencesRolesRoleIdEditRoute
  '/preferences/entityTypes/$entityTypeId/': typeof AuthPreferencesEntityTypesEntityTypeIdIndexRoute
  '/preferences/roles/$roleId/': typeof AuthPreferencesRolesRoleIdIndexRoute
  '/embedded/dashboard/admin/powerbi/$reportId': typeof AuthEmbeddedDashboardAdminPowerbiReportIdRoute
  '/preferences/entityTypes/$entityTypeId/rules/$ruleId': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute
  '/preferences/entityTypes/$entityTypeId/rules/new': typeof AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute
}
export interface FileRoutesByTo {
  '/403': typeof Auth403Route
  '/404': typeof Auth404Route
  '/calcstatus': typeof AuthCalcstatusRoute
  '/card': typeof AuthCardRouteWithChildren
  '/components': typeof AuthComponentsRoute
  '/designer': typeof AuthDesignerRoute
  '/grid': typeof AuthGridRoute
  '/host': typeof AuthHostRoute
  '/profile': typeof AuthProfileRoute
  '/reports': typeof AuthReportsRoute
  '/create': typeof LegacyCreateRoute
  '/dashboards': typeof LegacyDashboardsRoute
  '/home': typeof LegacyHomeRoute
  '/continue-logout': typeof LoginContinueLogoutRoute
  '/login': typeof LoginLoginRoute
  '/resume': typeof LoginResumeRoute
  '/login/inactive': typeof LoginInactiveRoute
  '/login/license-limit': typeof LoginLicenseLimitRoute
  '/login/organization-busy': typeof LoginOrganizationBusyRoute
  '/': typeof AuthIndexRoute
  '/card/filter': typeof AuthCardFilterRoute
  '/entity/new': typeof AuthEntityNewRoute
  '/insights/$dashboardId': typeof AuthInsightsDashboardIdRoute
  '/insights/dashboards': typeof AuthInsightsDashboardsRoute
  '/insights/reports': typeof AuthInsightsReportsRoute
  '/integrations/$': typeof AuthIntegrationsSplatRoute
  '/preferences/conditional': typeof AuthPreferencesConditionalRoute
  '/preferences/datasheets': typeof AuthPreferencesDatasheetsRoute
  '/preferences/documents': typeof AuthPreferencesDocumentsRoute
  '/preferences/fieldPermissions': typeof AuthPreferencesFieldPermissionsRoute
  '/preferences/globalTables': typeof AuthPreferencesGlobalTablesRoute
  '/preferences/groups': typeof AuthPreferencesGroupsRoute
  '/preferences/homepage-dashboard': typeof AuthPreferencesHomepageDashboardRoute
  '/preferences/insights-dashboard': typeof AuthPreferencesInsightsDashboardRoute
  '/preferences/management': typeof AuthPreferencesManagementRoute
  '/preferences/menu-designer': typeof AuthPreferencesMenuDesignerRoute
  '/preferences/model': typeof AuthPreferencesModelRoute
  '/preferences/modelSetting': typeof AuthPreferencesModelSettingRoute
  '/preferences/oauthAdmin': typeof AuthPreferencesOauthAdminRoute
  '/preferences/organization': typeof AuthPreferencesOrganizationRoute
  '/preferences/recycle': typeof AuthPreferencesRecycleRoute
  '/preferences/summary-dashboard': typeof AuthPreferencesSummaryDashboardRoute
  '/preferences/summary-dashboard-settings': typeof AuthPreferencesSummaryDashboardSettingsRoute
  '/preferences/teams': typeof AuthPreferencesTeamsRoute
  '/terminal-connect/embed': typeof AuthTerminalConnectEmbedRoute
  '/entities/$': typeof LegacyEntitiesSplatRoute
  '/preferences': typeof AuthPreferencesIndexRoute
  '/terminal-connect': typeof AuthTerminalConnectIndexRoute
  '/entity/$entityId': typeof AuthEntityEntityIdIndexRoute
  '/preferences/dashboards/$dashboardId': typeof AuthPreferencesDashboardsDashboardIdRoute
  '/preferences/dashboards/new': typeof AuthPreferencesDashboardsNewRoute
  '/preferences/navigation-bar/org-logo': typeof AuthPreferencesNavigationBarOrgLogoRoute
  '/preferences/users/$userId': typeof AuthPreferencesUsersUserIdRoute
  '/preferences/users/new': typeof AuthPreferencesUsersNewRoute
  '/preferences/dashboards': typeof AuthPreferencesDashboardsIndexRoute
  '/preferences/entityTypes': typeof AuthPreferencesEntityTypesIndexRoute
  '/preferences/navigation-bar': typeof AuthPreferencesNavigationBarIndexRoute
  '/preferences/roles': typeof AuthPreferencesRolesIndexRoute
  '/preferences/users': typeof AuthPreferencesUsersIndexRoute
  '/preferences/entityTypes/$entityTypeId/rules': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren
  '/entity/$entityId/$subEntityCode': typeof AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute
  '/entity/$entityId/calculationLog': typeof AuthEntityEntityIdBreadcrumbsCalculationLogRoute
  '/entity/$entityId/details': typeof AuthEntityEntityIdBreadcrumbsDetailsRoute
  '/entity/$entityId/exploration': typeof AuthEntityEntityIdBreadcrumbsExplorationRoute
  '/entity/$entityId/links': typeof AuthEntityEntityIdBreadcrumbsLinksRoute
  '/entity/$entityId/models': typeof AuthEntityEntityIdBreadcrumbsModelsRoute
  '/entity/$entityId/notes': typeof AuthEntityEntityIdBreadcrumbsNotesRoute
  '/entity/$entityId/relationships': typeof AuthEntityEntityIdBreadcrumbsRelationshipsRoute
  '/entity/$entityId/summary': typeof AuthEntityEntityIdBreadcrumbsSummaryRoute
  '/preferences/entityTypes/$entityTypeId/fields': typeof AuthPreferencesEntityTypesEntityTypeIdFieldsRoute
  '/preferences/entityTypes/$entityTypeId/recurrences': typeof AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute
  '/preferences/entityTypes/$entityTypeId/stages': typeof AuthPreferencesEntityTypesEntityTypeIdStagesRoute
  '/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity': typeof AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute
  '/preferences/roles/$roleId/edit': typeof AuthPreferencesRolesRoleIdEditRoute
  '/preferences/entityTypes/$entityTypeId': typeof AuthPreferencesEntityTypesEntityTypeIdIndexRoute
  '/preferences/roles/$roleId': typeof AuthPreferencesRolesRoleIdIndexRoute
  '/embedded/dashboard/admin/powerbi/$reportId': typeof AuthEmbeddedDashboardAdminPowerbiReportIdRoute
  '/preferences/entityTypes/$entityTypeId/rules/$ruleId': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute
  '/preferences/entityTypes/$entityTypeId/rules/new': typeof AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_auth/preferences': typeof AuthPreferencesRouteRouteWithChildren
  '/_auth/terminal-connect': typeof AuthTerminalConnectRouteRouteWithChildren
  '/_auth/403': typeof Auth403Route
  '/_auth/404': typeof Auth404Route
  '/_auth/calcstatus': typeof AuthCalcstatusRoute
  '/_auth/card': typeof AuthCardRouteWithChildren
  '/_auth/components': typeof AuthComponentsRoute
  '/_auth/designer': typeof AuthDesignerRoute
  '/_auth/grid': typeof AuthGridRoute
  '/_auth/host': typeof AuthHostRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_auth/reports': typeof AuthReportsRoute
  '/_legacy/create': typeof LegacyCreateRoute
  '/_legacy/dashboards': typeof LegacyDashboardsRoute
  '/_legacy/home': typeof LegacyHomeRoute
  '/_login/continue-logout': typeof LoginContinueLogoutRoute
  '/_login/login': typeof LoginLoginRoute
  '/_login/resume': typeof LoginResumeRoute
  '/login/inactive': typeof LoginInactiveRoute
  '/login/license-limit': typeof LoginLicenseLimitRoute
  '/login/organization-busy': typeof LoginOrganizationBusyRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/entity/$entityId': typeof AuthEntityEntityIdRouteRouteWithChildren
  '/_auth/preferences/dashboards': typeof AuthPreferencesDashboardsRouteRouteWithChildren
  '/_auth/preferences/entityTypes': typeof AuthPreferencesEntityTypesRouteRouteWithChildren
  '/_auth/preferences/navigation-bar': typeof AuthPreferencesNavigationBarRouteRouteWithChildren
  '/_auth/preferences/roles': typeof AuthPreferencesRolesRouteRouteWithChildren
  '/_auth/preferences/users': typeof AuthPreferencesUsersRouteRouteWithChildren
  '/_auth/card/filter': typeof AuthCardFilterRoute
  '/_auth/entity/new': typeof AuthEntityNewRoute
  '/_auth/insights/$dashboardId': typeof AuthInsightsDashboardIdRoute
  '/_auth/insights/dashboards': typeof AuthInsightsDashboardsRoute
  '/_auth/insights/reports': typeof AuthInsightsReportsRoute
  '/_auth/integrations/$': typeof AuthIntegrationsSplatRoute
  '/_auth/preferences/conditional': typeof AuthPreferencesConditionalRoute
  '/_auth/preferences/datasheets': typeof AuthPreferencesDatasheetsRoute
  '/_auth/preferences/documents': typeof AuthPreferencesDocumentsRoute
  '/_auth/preferences/fieldPermissions': typeof AuthPreferencesFieldPermissionsRoute
  '/_auth/preferences/globalTables': typeof AuthPreferencesGlobalTablesRoute
  '/_auth/preferences/groups': typeof AuthPreferencesGroupsRoute
  '/_auth/preferences/homepage-dashboard': typeof AuthPreferencesHomepageDashboardRoute
  '/_auth/preferences/insights-dashboard': typeof AuthPreferencesInsightsDashboardRoute
  '/_auth/preferences/management': typeof AuthPreferencesManagementRoute
  '/_auth/preferences/menu-designer': typeof AuthPreferencesMenuDesignerRoute
  '/_auth/preferences/model': typeof AuthPreferencesModelRoute
  '/_auth/preferences/modelSetting': typeof AuthPreferencesModelSettingRoute
  '/_auth/preferences/oauthAdmin': typeof AuthPreferencesOauthAdminRoute
  '/_auth/preferences/organization': typeof AuthPreferencesOrganizationRoute
  '/_auth/preferences/recycle': typeof AuthPreferencesRecycleRoute
  '/_auth/preferences/summary-dashboard': typeof AuthPreferencesSummaryDashboardRoute
  '/_auth/preferences/summary-dashboard-settings': typeof AuthPreferencesSummaryDashboardSettingsRoute
  '/_auth/preferences/teams': typeof AuthPreferencesTeamsRoute
  '/_auth/terminal-connect/embed': typeof AuthTerminalConnectEmbedRoute
  '/_legacy/entities/$': typeof LegacyEntitiesSplatRoute
  '/_auth/preferences/': typeof AuthPreferencesIndexRoute
  '/_auth/terminal-connect/': typeof AuthTerminalConnectIndexRoute
  '/_auth/entity/$entityId/_breadcrumbs': typeof AuthEntityEntityIdBreadcrumbsRouteRouteWithChildren
  '/_auth/preferences/entityTypes/$entityTypeId': typeof AuthPreferencesEntityTypesEntityTypeIdRouteRouteWithChildren
  '/_auth/preferences/roles/$roleId': typeof AuthPreferencesRolesRoleIdRouteRouteWithChildren
  '/_auth/preferences/dashboards/$dashboardId': typeof AuthPreferencesDashboardsDashboardIdRoute
  '/_auth/preferences/dashboards/new': typeof AuthPreferencesDashboardsNewRoute
  '/_auth/preferences/navigation-bar/org-logo': typeof AuthPreferencesNavigationBarOrgLogoRoute
  '/_auth/preferences/users/$userId': typeof AuthPreferencesUsersUserIdRoute
  '/_auth/preferences/users/new': typeof AuthPreferencesUsersNewRoute
  '/_auth/entity/$entityId/': typeof AuthEntityEntityIdIndexRoute
  '/_auth/preferences/dashboards/': typeof AuthPreferencesDashboardsIndexRoute
  '/_auth/preferences/entityTypes/': typeof AuthPreferencesEntityTypesIndexRoute
  '/_auth/preferences/navigation-bar/': typeof AuthPreferencesNavigationBarIndexRoute
  '/_auth/preferences/roles/': typeof AuthPreferencesRolesIndexRoute
  '/_auth/preferences/users/': typeof AuthPreferencesUsersIndexRoute
  '/_auth/preferences/entityTypes/$entityTypeId/rules': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren
  '/_auth/entity/$entityId/_breadcrumbs/$subEntityCode': typeof AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute
  '/_auth/entity/$entityId/_breadcrumbs/calculationLog': typeof AuthEntityEntityIdBreadcrumbsCalculationLogRoute
  '/_auth/entity/$entityId/_breadcrumbs/details': typeof AuthEntityEntityIdBreadcrumbsDetailsRoute
  '/_auth/entity/$entityId/_breadcrumbs/exploration': typeof AuthEntityEntityIdBreadcrumbsExplorationRoute
  '/_auth/entity/$entityId/_breadcrumbs/links': typeof AuthEntityEntityIdBreadcrumbsLinksRoute
  '/_auth/entity/$entityId/_breadcrumbs/models': typeof AuthEntityEntityIdBreadcrumbsModelsRoute
  '/_auth/entity/$entityId/_breadcrumbs/notes': typeof AuthEntityEntityIdBreadcrumbsNotesRoute
  '/_auth/entity/$entityId/_breadcrumbs/relationships': typeof AuthEntityEntityIdBreadcrumbsRelationshipsRoute
  '/_auth/entity/$entityId/_breadcrumbs/summary': typeof AuthEntityEntityIdBreadcrumbsSummaryRoute
  '/_auth/preferences/entityTypes/$entityTypeId/fields': typeof AuthPreferencesEntityTypesEntityTypeIdFieldsRoute
  '/_auth/preferences/entityTypes/$entityTypeId/recurrences': typeof AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute
  '/_auth/preferences/entityTypes/$entityTypeId/stages': typeof AuthPreferencesEntityTypesEntityTypeIdStagesRoute
  '/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity': typeof AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute
  '/_auth/preferences/roles/$roleId/edit': typeof AuthPreferencesRolesRoleIdEditRoute
  '/_auth/preferences/entityTypes/$entityTypeId/': typeof AuthPreferencesEntityTypesEntityTypeIdIndexRoute
  '/_auth/preferences/roles/$roleId/': typeof AuthPreferencesRolesRoleIdIndexRoute
  '/_auth/embedded/dashboard/admin/powerbi/$reportId': typeof AuthEmbeddedDashboardAdminPowerbiReportIdRoute
  '/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId': typeof AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute
  '/_auth/preferences/entityTypes/$entityTypeId/rules/new': typeof AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/preferences'
    | '/terminal-connect'
    | '/403'
    | '/404'
    | '/calcstatus'
    | '/card'
    | '/components'
    | '/designer'
    | '/grid'
    | '/host'
    | '/profile'
    | '/reports'
    | '/create'
    | '/dashboards'
    | '/home'
    | '/continue-logout'
    | '/login'
    | '/resume'
    | '/login/inactive'
    | '/login/license-limit'
    | '/login/organization-busy'
    | '/entity/$entityId'
    | '/preferences/dashboards'
    | '/preferences/entityTypes'
    | '/preferences/navigation-bar'
    | '/preferences/roles'
    | '/preferences/users'
    | '/card/filter'
    | '/entity/new'
    | '/insights/$dashboardId'
    | '/insights/dashboards'
    | '/insights/reports'
    | '/integrations/$'
    | '/preferences/conditional'
    | '/preferences/datasheets'
    | '/preferences/documents'
    | '/preferences/fieldPermissions'
    | '/preferences/globalTables'
    | '/preferences/groups'
    | '/preferences/homepage-dashboard'
    | '/preferences/insights-dashboard'
    | '/preferences/management'
    | '/preferences/menu-designer'
    | '/preferences/model'
    | '/preferences/modelSetting'
    | '/preferences/oauthAdmin'
    | '/preferences/organization'
    | '/preferences/recycle'
    | '/preferences/summary-dashboard'
    | '/preferences/summary-dashboard-settings'
    | '/preferences/teams'
    | '/terminal-connect/embed'
    | '/entities/$'
    | '/preferences/'
    | '/terminal-connect/'
    | '/preferences/entityTypes/$entityTypeId'
    | '/preferences/roles/$roleId'
    | '/preferences/dashboards/$dashboardId'
    | '/preferences/dashboards/new'
    | '/preferences/navigation-bar/org-logo'
    | '/preferences/users/$userId'
    | '/preferences/users/new'
    | '/entity/$entityId/'
    | '/preferences/dashboards/'
    | '/preferences/entityTypes/'
    | '/preferences/navigation-bar/'
    | '/preferences/roles/'
    | '/preferences/users/'
    | '/preferences/entityTypes/$entityTypeId/rules'
    | '/entity/$entityId/$subEntityCode'
    | '/entity/$entityId/calculationLog'
    | '/entity/$entityId/details'
    | '/entity/$entityId/exploration'
    | '/entity/$entityId/links'
    | '/entity/$entityId/models'
    | '/entity/$entityId/notes'
    | '/entity/$entityId/relationships'
    | '/entity/$entityId/summary'
    | '/preferences/entityTypes/$entityTypeId/fields'
    | '/preferences/entityTypes/$entityTypeId/recurrences'
    | '/preferences/entityTypes/$entityTypeId/stages'
    | '/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
    | '/preferences/roles/$roleId/edit'
    | '/preferences/entityTypes/$entityTypeId/'
    | '/preferences/roles/$roleId/'
    | '/embedded/dashboard/admin/powerbi/$reportId'
    | '/preferences/entityTypes/$entityTypeId/rules/$ruleId'
    | '/preferences/entityTypes/$entityTypeId/rules/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/403'
    | '/404'
    | '/calcstatus'
    | '/card'
    | '/components'
    | '/designer'
    | '/grid'
    | '/host'
    | '/profile'
    | '/reports'
    | '/create'
    | '/dashboards'
    | '/home'
    | '/continue-logout'
    | '/login'
    | '/resume'
    | '/login/inactive'
    | '/login/license-limit'
    | '/login/organization-busy'
    | '/'
    | '/card/filter'
    | '/entity/new'
    | '/insights/$dashboardId'
    | '/insights/dashboards'
    | '/insights/reports'
    | '/integrations/$'
    | '/preferences/conditional'
    | '/preferences/datasheets'
    | '/preferences/documents'
    | '/preferences/fieldPermissions'
    | '/preferences/globalTables'
    | '/preferences/groups'
    | '/preferences/homepage-dashboard'
    | '/preferences/insights-dashboard'
    | '/preferences/management'
    | '/preferences/menu-designer'
    | '/preferences/model'
    | '/preferences/modelSetting'
    | '/preferences/oauthAdmin'
    | '/preferences/organization'
    | '/preferences/recycle'
    | '/preferences/summary-dashboard'
    | '/preferences/summary-dashboard-settings'
    | '/preferences/teams'
    | '/terminal-connect/embed'
    | '/entities/$'
    | '/preferences'
    | '/terminal-connect'
    | '/entity/$entityId'
    | '/preferences/dashboards/$dashboardId'
    | '/preferences/dashboards/new'
    | '/preferences/navigation-bar/org-logo'
    | '/preferences/users/$userId'
    | '/preferences/users/new'
    | '/preferences/dashboards'
    | '/preferences/entityTypes'
    | '/preferences/navigation-bar'
    | '/preferences/roles'
    | '/preferences/users'
    | '/preferences/entityTypes/$entityTypeId/rules'
    | '/entity/$entityId/$subEntityCode'
    | '/entity/$entityId/calculationLog'
    | '/entity/$entityId/details'
    | '/entity/$entityId/exploration'
    | '/entity/$entityId/links'
    | '/entity/$entityId/models'
    | '/entity/$entityId/notes'
    | '/entity/$entityId/relationships'
    | '/entity/$entityId/summary'
    | '/preferences/entityTypes/$entityTypeId/fields'
    | '/preferences/entityTypes/$entityTypeId/recurrences'
    | '/preferences/entityTypes/$entityTypeId/stages'
    | '/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
    | '/preferences/roles/$roleId/edit'
    | '/preferences/entityTypes/$entityTypeId'
    | '/preferences/roles/$roleId'
    | '/embedded/dashboard/admin/powerbi/$reportId'
    | '/preferences/entityTypes/$entityTypeId/rules/$ruleId'
    | '/preferences/entityTypes/$entityTypeId/rules/new'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/preferences'
    | '/_auth/terminal-connect'
    | '/_auth/403'
    | '/_auth/404'
    | '/_auth/calcstatus'
    | '/_auth/card'
    | '/_auth/components'
    | '/_auth/designer'
    | '/_auth/grid'
    | '/_auth/host'
    | '/_auth/profile'
    | '/_auth/reports'
    | '/_legacy/create'
    | '/_legacy/dashboards'
    | '/_legacy/home'
    | '/_login/continue-logout'
    | '/_login/login'
    | '/_login/resume'
    | '/login/inactive'
    | '/login/license-limit'
    | '/login/organization-busy'
    | '/_auth/'
    | '/_auth/entity/$entityId'
    | '/_auth/preferences/dashboards'
    | '/_auth/preferences/entityTypes'
    | '/_auth/preferences/navigation-bar'
    | '/_auth/preferences/roles'
    | '/_auth/preferences/users'
    | '/_auth/card/filter'
    | '/_auth/entity/new'
    | '/_auth/insights/$dashboardId'
    | '/_auth/insights/dashboards'
    | '/_auth/insights/reports'
    | '/_auth/integrations/$'
    | '/_auth/preferences/conditional'
    | '/_auth/preferences/datasheets'
    | '/_auth/preferences/documents'
    | '/_auth/preferences/fieldPermissions'
    | '/_auth/preferences/globalTables'
    | '/_auth/preferences/groups'
    | '/_auth/preferences/homepage-dashboard'
    | '/_auth/preferences/insights-dashboard'
    | '/_auth/preferences/management'
    | '/_auth/preferences/menu-designer'
    | '/_auth/preferences/model'
    | '/_auth/preferences/modelSetting'
    | '/_auth/preferences/oauthAdmin'
    | '/_auth/preferences/organization'
    | '/_auth/preferences/recycle'
    | '/_auth/preferences/summary-dashboard'
    | '/_auth/preferences/summary-dashboard-settings'
    | '/_auth/preferences/teams'
    | '/_auth/terminal-connect/embed'
    | '/_legacy/entities/$'
    | '/_auth/preferences/'
    | '/_auth/terminal-connect/'
    | '/_auth/entity/$entityId/_breadcrumbs'
    | '/_auth/preferences/entityTypes/$entityTypeId'
    | '/_auth/preferences/roles/$roleId'
    | '/_auth/preferences/dashboards/$dashboardId'
    | '/_auth/preferences/dashboards/new'
    | '/_auth/preferences/navigation-bar/org-logo'
    | '/_auth/preferences/users/$userId'
    | '/_auth/preferences/users/new'
    | '/_auth/entity/$entityId/'
    | '/_auth/preferences/dashboards/'
    | '/_auth/preferences/entityTypes/'
    | '/_auth/preferences/navigation-bar/'
    | '/_auth/preferences/roles/'
    | '/_auth/preferences/users/'
    | '/_auth/preferences/entityTypes/$entityTypeId/rules'
    | '/_auth/entity/$entityId/_breadcrumbs/$subEntityCode'
    | '/_auth/entity/$entityId/_breadcrumbs/calculationLog'
    | '/_auth/entity/$entityId/_breadcrumbs/details'
    | '/_auth/entity/$entityId/_breadcrumbs/exploration'
    | '/_auth/entity/$entityId/_breadcrumbs/links'
    | '/_auth/entity/$entityId/_breadcrumbs/models'
    | '/_auth/entity/$entityId/_breadcrumbs/notes'
    | '/_auth/entity/$entityId/_breadcrumbs/relationships'
    | '/_auth/entity/$entityId/_breadcrumbs/summary'
    | '/_auth/preferences/entityTypes/$entityTypeId/fields'
    | '/_auth/preferences/entityTypes/$entityTypeId/recurrences'
    | '/_auth/preferences/entityTypes/$entityTypeId/stages'
    | '/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
    | '/_auth/preferences/roles/$roleId/edit'
    | '/_auth/preferences/entityTypes/$entityTypeId/'
    | '/_auth/preferences/roles/$roleId/'
    | '/_auth/embedded/dashboard/admin/powerbi/$reportId'
    | '/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId'
    | '/_auth/preferences/entityTypes/$entityTypeId/rules/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LegacyCreateRoute: typeof LegacyCreateRoute
  LegacyDashboardsRoute: typeof LegacyDashboardsRoute
  LegacyHomeRoute: typeof LegacyHomeRoute
  LoginContinueLogoutRoute: typeof LoginContinueLogoutRoute
  LoginLoginRoute: typeof LoginLoginRoute
  LoginResumeRoute: typeof LoginResumeRoute
  LoginInactiveRoute: typeof LoginInactiveRoute
  LoginLicenseLimitRoute: typeof LoginLicenseLimitRoute
  LoginOrganizationBusyRoute: typeof LoginOrganizationBusyRoute
  LegacyEntitiesSplatRoute: typeof LegacyEntitiesSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/login/organization-busy': {
      id: '/login/organization-busy'
      path: '/login/organization-busy'
      fullPath: '/login/organization-busy'
      preLoaderRoute: typeof LoginOrganizationBusyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/license-limit': {
      id: '/login/license-limit'
      path: '/login/license-limit'
      fullPath: '/login/license-limit'
      preLoaderRoute: typeof LoginLicenseLimitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/inactive': {
      id: '/login/inactive'
      path: '/login/inactive'
      fullPath: '/login/inactive'
      preLoaderRoute: typeof LoginInactiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/resume': {
      id: '/_login/resume'
      path: '/resume'
      fullPath: '/resume'
      preLoaderRoute: typeof LoginResumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/login': {
      id: '/_login/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login/continue-logout': {
      id: '/_login/continue-logout'
      path: '/continue-logout'
      fullPath: '/continue-logout'
      preLoaderRoute: typeof LoginContinueLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legacy/home': {
      id: '/_legacy/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof LegacyHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legacy/dashboards': {
      id: '/_legacy/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof LegacyDashboardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_legacy/create': {
      id: '/_legacy/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof LegacyCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/reports': {
      id: '/_auth/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthReportsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/host': {
      id: '/_auth/host'
      path: '/host'
      fullPath: '/host'
      preLoaderRoute: typeof AuthHostRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/grid': {
      id: '/_auth/grid'
      path: '/grid'
      fullPath: '/grid'
      preLoaderRoute: typeof AuthGridRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/designer': {
      id: '/_auth/designer'
      path: '/designer'
      fullPath: '/designer'
      preLoaderRoute: typeof AuthDesignerRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/components': {
      id: '/_auth/components'
      path: '/components'
      fullPath: '/components'
      preLoaderRoute: typeof AuthComponentsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/card': {
      id: '/_auth/card'
      path: '/card'
      fullPath: '/card'
      preLoaderRoute: typeof AuthCardRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/calcstatus': {
      id: '/_auth/calcstatus'
      path: '/calcstatus'
      fullPath: '/calcstatus'
      preLoaderRoute: typeof AuthCalcstatusRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/404': {
      id: '/_auth/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Auth404RouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/403': {
      id: '/_auth/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Auth403RouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/terminal-connect': {
      id: '/_auth/terminal-connect'
      path: '/terminal-connect'
      fullPath: '/terminal-connect'
      preLoaderRoute: typeof AuthTerminalConnectRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/preferences': {
      id: '/_auth/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof AuthPreferencesRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/terminal-connect/': {
      id: '/_auth/terminal-connect/'
      path: '/'
      fullPath: '/terminal-connect/'
      preLoaderRoute: typeof AuthTerminalConnectIndexRouteImport
      parentRoute: typeof AuthTerminalConnectRouteRoute
    }
    '/_auth/preferences/': {
      id: '/_auth/preferences/'
      path: '/'
      fullPath: '/preferences/'
      preLoaderRoute: typeof AuthPreferencesIndexRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_legacy/entities/$': {
      id: '/_legacy/entities/$'
      path: '/entities/$'
      fullPath: '/entities/$'
      preLoaderRoute: typeof LegacyEntitiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/terminal-connect/embed': {
      id: '/_auth/terminal-connect/embed'
      path: '/embed'
      fullPath: '/terminal-connect/embed'
      preLoaderRoute: typeof AuthTerminalConnectEmbedRouteImport
      parentRoute: typeof AuthTerminalConnectRouteRoute
    }
    '/_auth/preferences/teams': {
      id: '/_auth/preferences/teams'
      path: '/teams'
      fullPath: '/preferences/teams'
      preLoaderRoute: typeof AuthPreferencesTeamsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/summary-dashboard-settings': {
      id: '/_auth/preferences/summary-dashboard-settings'
      path: '/summary-dashboard-settings'
      fullPath: '/preferences/summary-dashboard-settings'
      preLoaderRoute: typeof AuthPreferencesSummaryDashboardSettingsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/summary-dashboard': {
      id: '/_auth/preferences/summary-dashboard'
      path: '/summary-dashboard'
      fullPath: '/preferences/summary-dashboard'
      preLoaderRoute: typeof AuthPreferencesSummaryDashboardRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/recycle': {
      id: '/_auth/preferences/recycle'
      path: '/recycle'
      fullPath: '/preferences/recycle'
      preLoaderRoute: typeof AuthPreferencesRecycleRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/organization': {
      id: '/_auth/preferences/organization'
      path: '/organization'
      fullPath: '/preferences/organization'
      preLoaderRoute: typeof AuthPreferencesOrganizationRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/oauthAdmin': {
      id: '/_auth/preferences/oauthAdmin'
      path: '/oauthAdmin'
      fullPath: '/preferences/oauthAdmin'
      preLoaderRoute: typeof AuthPreferencesOauthAdminRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/modelSetting': {
      id: '/_auth/preferences/modelSetting'
      path: '/modelSetting'
      fullPath: '/preferences/modelSetting'
      preLoaderRoute: typeof AuthPreferencesModelSettingRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/model': {
      id: '/_auth/preferences/model'
      path: '/model'
      fullPath: '/preferences/model'
      preLoaderRoute: typeof AuthPreferencesModelRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/menu-designer': {
      id: '/_auth/preferences/menu-designer'
      path: '/menu-designer'
      fullPath: '/preferences/menu-designer'
      preLoaderRoute: typeof AuthPreferencesMenuDesignerRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/management': {
      id: '/_auth/preferences/management'
      path: '/management'
      fullPath: '/preferences/management'
      preLoaderRoute: typeof AuthPreferencesManagementRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/insights-dashboard': {
      id: '/_auth/preferences/insights-dashboard'
      path: '/insights-dashboard'
      fullPath: '/preferences/insights-dashboard'
      preLoaderRoute: typeof AuthPreferencesInsightsDashboardRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/homepage-dashboard': {
      id: '/_auth/preferences/homepage-dashboard'
      path: '/homepage-dashboard'
      fullPath: '/preferences/homepage-dashboard'
      preLoaderRoute: typeof AuthPreferencesHomepageDashboardRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/groups': {
      id: '/_auth/preferences/groups'
      path: '/groups'
      fullPath: '/preferences/groups'
      preLoaderRoute: typeof AuthPreferencesGroupsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/globalTables': {
      id: '/_auth/preferences/globalTables'
      path: '/globalTables'
      fullPath: '/preferences/globalTables'
      preLoaderRoute: typeof AuthPreferencesGlobalTablesRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/fieldPermissions': {
      id: '/_auth/preferences/fieldPermissions'
      path: '/fieldPermissions'
      fullPath: '/preferences/fieldPermissions'
      preLoaderRoute: typeof AuthPreferencesFieldPermissionsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/documents': {
      id: '/_auth/preferences/documents'
      path: '/documents'
      fullPath: '/preferences/documents'
      preLoaderRoute: typeof AuthPreferencesDocumentsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/datasheets': {
      id: '/_auth/preferences/datasheets'
      path: '/datasheets'
      fullPath: '/preferences/datasheets'
      preLoaderRoute: typeof AuthPreferencesDatasheetsRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/conditional': {
      id: '/_auth/preferences/conditional'
      path: '/conditional'
      fullPath: '/preferences/conditional'
      preLoaderRoute: typeof AuthPreferencesConditionalRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/integrations/$': {
      id: '/_auth/integrations/$'
      path: '/integrations/$'
      fullPath: '/integrations/$'
      preLoaderRoute: typeof AuthIntegrationsSplatRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/insights/reports': {
      id: '/_auth/insights/reports'
      path: '/insights/reports'
      fullPath: '/insights/reports'
      preLoaderRoute: typeof AuthInsightsReportsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/insights/dashboards': {
      id: '/_auth/insights/dashboards'
      path: '/insights/dashboards'
      fullPath: '/insights/dashboards'
      preLoaderRoute: typeof AuthInsightsDashboardsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/insights/$dashboardId': {
      id: '/_auth/insights/$dashboardId'
      path: '/insights/$dashboardId'
      fullPath: '/insights/$dashboardId'
      preLoaderRoute: typeof AuthInsightsDashboardIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/entity/new': {
      id: '/_auth/entity/new'
      path: '/entity/new'
      fullPath: '/entity/new'
      preLoaderRoute: typeof AuthEntityNewRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/card/filter': {
      id: '/_auth/card/filter'
      path: '/filter'
      fullPath: '/card/filter'
      preLoaderRoute: typeof AuthCardFilterRouteImport
      parentRoute: typeof AuthCardRoute
    }
    '/_auth/preferences/users': {
      id: '/_auth/preferences/users'
      path: '/users'
      fullPath: '/preferences/users'
      preLoaderRoute: typeof AuthPreferencesUsersRouteRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/roles': {
      id: '/_auth/preferences/roles'
      path: '/roles'
      fullPath: '/preferences/roles'
      preLoaderRoute: typeof AuthPreferencesRolesRouteRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/navigation-bar': {
      id: '/_auth/preferences/navigation-bar'
      path: '/navigation-bar'
      fullPath: '/preferences/navigation-bar'
      preLoaderRoute: typeof AuthPreferencesNavigationBarRouteRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/entityTypes': {
      id: '/_auth/preferences/entityTypes'
      path: '/entityTypes'
      fullPath: '/preferences/entityTypes'
      preLoaderRoute: typeof AuthPreferencesEntityTypesRouteRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/preferences/dashboards': {
      id: '/_auth/preferences/dashboards'
      path: '/dashboards'
      fullPath: '/preferences/dashboards'
      preLoaderRoute: typeof AuthPreferencesDashboardsRouteRouteImport
      parentRoute: typeof AuthPreferencesRouteRoute
    }
    '/_auth/entity/$entityId': {
      id: '/_auth/entity/$entityId'
      path: '/entity/$entityId'
      fullPath: '/entity/$entityId'
      preLoaderRoute: typeof AuthEntityEntityIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/preferences/users/': {
      id: '/_auth/preferences/users/'
      path: '/'
      fullPath: '/preferences/users/'
      preLoaderRoute: typeof AuthPreferencesUsersIndexRouteImport
      parentRoute: typeof AuthPreferencesUsersRouteRoute
    }
    '/_auth/preferences/roles/': {
      id: '/_auth/preferences/roles/'
      path: '/'
      fullPath: '/preferences/roles/'
      preLoaderRoute: typeof AuthPreferencesRolesIndexRouteImport
      parentRoute: typeof AuthPreferencesRolesRouteRoute
    }
    '/_auth/preferences/navigation-bar/': {
      id: '/_auth/preferences/navigation-bar/'
      path: '/'
      fullPath: '/preferences/navigation-bar/'
      preLoaderRoute: typeof AuthPreferencesNavigationBarIndexRouteImport
      parentRoute: typeof AuthPreferencesNavigationBarRouteRoute
    }
    '/_auth/preferences/entityTypes/': {
      id: '/_auth/preferences/entityTypes/'
      path: '/'
      fullPath: '/preferences/entityTypes/'
      preLoaderRoute: typeof AuthPreferencesEntityTypesIndexRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesRouteRoute
    }
    '/_auth/preferences/dashboards/': {
      id: '/_auth/preferences/dashboards/'
      path: '/'
      fullPath: '/preferences/dashboards/'
      preLoaderRoute: typeof AuthPreferencesDashboardsIndexRouteImport
      parentRoute: typeof AuthPreferencesDashboardsRouteRoute
    }
    '/_auth/entity/$entityId/': {
      id: '/_auth/entity/$entityId/'
      path: '/'
      fullPath: '/entity/$entityId/'
      preLoaderRoute: typeof AuthEntityEntityIdIndexRouteImport
      parentRoute: typeof AuthEntityEntityIdRouteRoute
    }
    '/_auth/preferences/users/new': {
      id: '/_auth/preferences/users/new'
      path: '/new'
      fullPath: '/preferences/users/new'
      preLoaderRoute: typeof AuthPreferencesUsersNewRouteImport
      parentRoute: typeof AuthPreferencesUsersRouteRoute
    }
    '/_auth/preferences/users/$userId': {
      id: '/_auth/preferences/users/$userId'
      path: '/$userId'
      fullPath: '/preferences/users/$userId'
      preLoaderRoute: typeof AuthPreferencesUsersUserIdRouteImport
      parentRoute: typeof AuthPreferencesUsersRouteRoute
    }
    '/_auth/preferences/navigation-bar/org-logo': {
      id: '/_auth/preferences/navigation-bar/org-logo'
      path: '/org-logo'
      fullPath: '/preferences/navigation-bar/org-logo'
      preLoaderRoute: typeof AuthPreferencesNavigationBarOrgLogoRouteImport
      parentRoute: typeof AuthPreferencesNavigationBarRouteRoute
    }
    '/_auth/preferences/dashboards/new': {
      id: '/_auth/preferences/dashboards/new'
      path: '/new'
      fullPath: '/preferences/dashboards/new'
      preLoaderRoute: typeof AuthPreferencesDashboardsNewRouteImport
      parentRoute: typeof AuthPreferencesDashboardsRouteRoute
    }
    '/_auth/preferences/dashboards/$dashboardId': {
      id: '/_auth/preferences/dashboards/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/preferences/dashboards/$dashboardId'
      preLoaderRoute: typeof AuthPreferencesDashboardsDashboardIdRouteImport
      parentRoute: typeof AuthPreferencesDashboardsRouteRoute
    }
    '/_auth/preferences/roles/$roleId': {
      id: '/_auth/preferences/roles/$roleId'
      path: '/$roleId'
      fullPath: '/preferences/roles/$roleId'
      preLoaderRoute: typeof AuthPreferencesRolesRoleIdRouteRouteImport
      parentRoute: typeof AuthPreferencesRolesRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId': {
      id: '/_auth/preferences/entityTypes/$entityTypeId'
      path: '/$entityTypeId'
      fullPath: '/preferences/entityTypes/$entityTypeId'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs': {
      id: '/_auth/entity/$entityId/_breadcrumbs'
      path: ''
      fullPath: '/entity/$entityId'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRouteImport
      parentRoute: typeof AuthEntityEntityIdRouteRoute
    }
    '/_auth/preferences/roles/$roleId/': {
      id: '/_auth/preferences/roles/$roleId/'
      path: '/'
      fullPath: '/preferences/roles/$roleId/'
      preLoaderRoute: typeof AuthPreferencesRolesRoleIdIndexRouteImport
      parentRoute: typeof AuthPreferencesRolesRoleIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/'
      path: '/'
      fullPath: '/preferences/entityTypes/$entityTypeId/'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdIndexRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/preferences/roles/$roleId/edit': {
      id: '/_auth/preferences/roles/$roleId/edit'
      path: '/edit'
      fullPath: '/preferences/roles/$roleId/edit'
      preLoaderRoute: typeof AuthPreferencesRolesRoleIdEditRouteImport
      parentRoute: typeof AuthPreferencesRolesRoleIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
      path: '/timeSeriesSubEntity'
      fullPath: '/preferences/entityTypes/$entityTypeId/timeSeriesSubEntity'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/stages': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/stages'
      path: '/stages'
      fullPath: '/preferences/entityTypes/$entityTypeId/stages'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdStagesRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/recurrences': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/recurrences'
      path: '/recurrences'
      fullPath: '/preferences/entityTypes/$entityTypeId/recurrences'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRecurrencesRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/fields': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/fields'
      path: '/fields'
      fullPath: '/preferences/entityTypes/$entityTypeId/fields'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdFieldsRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/summary': {
      id: '/_auth/entity/$entityId/_breadcrumbs/summary'
      path: '/summary'
      fullPath: '/entity/$entityId/summary'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsSummaryRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/relationships': {
      id: '/_auth/entity/$entityId/_breadcrumbs/relationships'
      path: '/relationships'
      fullPath: '/entity/$entityId/relationships'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsRelationshipsRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/notes': {
      id: '/_auth/entity/$entityId/_breadcrumbs/notes'
      path: '/notes'
      fullPath: '/entity/$entityId/notes'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsNotesRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/models': {
      id: '/_auth/entity/$entityId/_breadcrumbs/models'
      path: '/models'
      fullPath: '/entity/$entityId/models'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsModelsRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/links': {
      id: '/_auth/entity/$entityId/_breadcrumbs/links'
      path: '/links'
      fullPath: '/entity/$entityId/links'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsLinksRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/exploration': {
      id: '/_auth/entity/$entityId/_breadcrumbs/exploration'
      path: '/exploration'
      fullPath: '/entity/$entityId/exploration'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsExplorationRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/details': {
      id: '/_auth/entity/$entityId/_breadcrumbs/details'
      path: '/details'
      fullPath: '/entity/$entityId/details'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsDetailsRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/calculationLog': {
      id: '/_auth/entity/$entityId/_breadcrumbs/calculationLog'
      path: '/calculationLog'
      fullPath: '/entity/$entityId/calculationLog'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsCalculationLogRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/entity/$entityId/_breadcrumbs/$subEntityCode': {
      id: '/_auth/entity/$entityId/_breadcrumbs/$subEntityCode'
      path: '/$subEntityCode'
      fullPath: '/entity/$entityId/$subEntityCode'
      preLoaderRoute: typeof AuthEntityEntityIdBreadcrumbsSubEntityCodeRouteImport
      parentRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/rules': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/rules'
      path: '/rules'
      fullPath: '/preferences/entityTypes/$entityTypeId/rules'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/rules/new': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/rules/new'
      path: '/new'
      fullPath: '/preferences/entityTypes/$entityTypeId/rules/new'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesNewRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute
    }
    '/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId': {
      id: '/_auth/preferences/entityTypes/$entityTypeId/rules/$ruleId'
      path: '/$ruleId'
      fullPath: '/preferences/entityTypes/$entityTypeId/rules/$ruleId'
      preLoaderRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRouteImport
      parentRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute
    }
    '/_auth/embedded/dashboard/admin/powerbi/$reportId': {
      id: '/_auth/embedded/dashboard/admin/powerbi/$reportId'
      path: '/embedded/dashboard/admin/powerbi/$reportId'
      fullPath: '/embedded/dashboard/admin/powerbi/$reportId'
      preLoaderRoute: typeof AuthEmbeddedDashboardAdminPowerbiReportIdRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthPreferencesDashboardsRouteRouteChildren {
  AuthPreferencesDashboardsDashboardIdRoute: typeof AuthPreferencesDashboardsDashboardIdRoute
  AuthPreferencesDashboardsNewRoute: typeof AuthPreferencesDashboardsNewRoute
  AuthPreferencesDashboardsIndexRoute: typeof AuthPreferencesDashboardsIndexRoute
}

const AuthPreferencesDashboardsRouteRouteChildren: AuthPreferencesDashboardsRouteRouteChildren =
  {
    AuthPreferencesDashboardsDashboardIdRoute:
      AuthPreferencesDashboardsDashboardIdRoute,
    AuthPreferencesDashboardsNewRoute: AuthPreferencesDashboardsNewRoute,
    AuthPreferencesDashboardsIndexRoute: AuthPreferencesDashboardsIndexRoute,
  }

const AuthPreferencesDashboardsRouteRouteWithChildren =
  AuthPreferencesDashboardsRouteRoute._addFileChildren(
    AuthPreferencesDashboardsRouteRouteChildren,
  )

interface AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteChildren {
  AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute
  AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute
}

const AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteChildren: AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteChildren =
  {
    AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute:
      AuthPreferencesEntityTypesEntityTypeIdRulesRuleIdRoute,
    AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute:
      AuthPreferencesEntityTypesEntityTypeIdRulesNewRoute,
  }

const AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren =
  AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute._addFileChildren(
    AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteChildren,
  )

interface AuthPreferencesEntityTypesEntityTypeIdRouteRouteChildren {
  AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren
  AuthPreferencesEntityTypesEntityTypeIdFieldsRoute: typeof AuthPreferencesEntityTypesEntityTypeIdFieldsRoute
  AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute
  AuthPreferencesEntityTypesEntityTypeIdStagesRoute: typeof AuthPreferencesEntityTypesEntityTypeIdStagesRoute
  AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute: typeof AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute
  AuthPreferencesEntityTypesEntityTypeIdIndexRoute: typeof AuthPreferencesEntityTypesEntityTypeIdIndexRoute
}

const AuthPreferencesEntityTypesEntityTypeIdRouteRouteChildren: AuthPreferencesEntityTypesEntityTypeIdRouteRouteChildren =
  {
    AuthPreferencesEntityTypesEntityTypeIdRulesRouteRoute:
      AuthPreferencesEntityTypesEntityTypeIdRulesRouteRouteWithChildren,
    AuthPreferencesEntityTypesEntityTypeIdFieldsRoute:
      AuthPreferencesEntityTypesEntityTypeIdFieldsRoute,
    AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute:
      AuthPreferencesEntityTypesEntityTypeIdRecurrencesRoute,
    AuthPreferencesEntityTypesEntityTypeIdStagesRoute:
      AuthPreferencesEntityTypesEntityTypeIdStagesRoute,
    AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute:
      AuthPreferencesEntityTypesEntityTypeIdTimeSeriesSubEntityRoute,
    AuthPreferencesEntityTypesEntityTypeIdIndexRoute:
      AuthPreferencesEntityTypesEntityTypeIdIndexRoute,
  }

const AuthPreferencesEntityTypesEntityTypeIdRouteRouteWithChildren =
  AuthPreferencesEntityTypesEntityTypeIdRouteRoute._addFileChildren(
    AuthPreferencesEntityTypesEntityTypeIdRouteRouteChildren,
  )

interface AuthPreferencesEntityTypesRouteRouteChildren {
  AuthPreferencesEntityTypesEntityTypeIdRouteRoute: typeof AuthPreferencesEntityTypesEntityTypeIdRouteRouteWithChildren
  AuthPreferencesEntityTypesIndexRoute: typeof AuthPreferencesEntityTypesIndexRoute
}

const AuthPreferencesEntityTypesRouteRouteChildren: AuthPreferencesEntityTypesRouteRouteChildren =
  {
    AuthPreferencesEntityTypesEntityTypeIdRouteRoute:
      AuthPreferencesEntityTypesEntityTypeIdRouteRouteWithChildren,
    AuthPreferencesEntityTypesIndexRoute: AuthPreferencesEntityTypesIndexRoute,
  }

const AuthPreferencesEntityTypesRouteRouteWithChildren =
  AuthPreferencesEntityTypesRouteRoute._addFileChildren(
    AuthPreferencesEntityTypesRouteRouteChildren,
  )

interface AuthPreferencesNavigationBarRouteRouteChildren {
  AuthPreferencesNavigationBarOrgLogoRoute: typeof AuthPreferencesNavigationBarOrgLogoRoute
  AuthPreferencesNavigationBarIndexRoute: typeof AuthPreferencesNavigationBarIndexRoute
}

const AuthPreferencesNavigationBarRouteRouteChildren: AuthPreferencesNavigationBarRouteRouteChildren =
  {
    AuthPreferencesNavigationBarOrgLogoRoute:
      AuthPreferencesNavigationBarOrgLogoRoute,
    AuthPreferencesNavigationBarIndexRoute:
      AuthPreferencesNavigationBarIndexRoute,
  }

const AuthPreferencesNavigationBarRouteRouteWithChildren =
  AuthPreferencesNavigationBarRouteRoute._addFileChildren(
    AuthPreferencesNavigationBarRouteRouteChildren,
  )

interface AuthPreferencesRolesRoleIdRouteRouteChildren {
  AuthPreferencesRolesRoleIdEditRoute: typeof AuthPreferencesRolesRoleIdEditRoute
  AuthPreferencesRolesRoleIdIndexRoute: typeof AuthPreferencesRolesRoleIdIndexRoute
}

const AuthPreferencesRolesRoleIdRouteRouteChildren: AuthPreferencesRolesRoleIdRouteRouteChildren =
  {
    AuthPreferencesRolesRoleIdEditRoute: AuthPreferencesRolesRoleIdEditRoute,
    AuthPreferencesRolesRoleIdIndexRoute: AuthPreferencesRolesRoleIdIndexRoute,
  }

const AuthPreferencesRolesRoleIdRouteRouteWithChildren =
  AuthPreferencesRolesRoleIdRouteRoute._addFileChildren(
    AuthPreferencesRolesRoleIdRouteRouteChildren,
  )

interface AuthPreferencesRolesRouteRouteChildren {
  AuthPreferencesRolesRoleIdRouteRoute: typeof AuthPreferencesRolesRoleIdRouteRouteWithChildren
  AuthPreferencesRolesIndexRoute: typeof AuthPreferencesRolesIndexRoute
}

const AuthPreferencesRolesRouteRouteChildren: AuthPreferencesRolesRouteRouteChildren =
  {
    AuthPreferencesRolesRoleIdRouteRoute:
      AuthPreferencesRolesRoleIdRouteRouteWithChildren,
    AuthPreferencesRolesIndexRoute: AuthPreferencesRolesIndexRoute,
  }

const AuthPreferencesRolesRouteRouteWithChildren =
  AuthPreferencesRolesRouteRoute._addFileChildren(
    AuthPreferencesRolesRouteRouteChildren,
  )

interface AuthPreferencesUsersRouteRouteChildren {
  AuthPreferencesUsersUserIdRoute: typeof AuthPreferencesUsersUserIdRoute
  AuthPreferencesUsersNewRoute: typeof AuthPreferencesUsersNewRoute
  AuthPreferencesUsersIndexRoute: typeof AuthPreferencesUsersIndexRoute
}

const AuthPreferencesUsersRouteRouteChildren: AuthPreferencesUsersRouteRouteChildren =
  {
    AuthPreferencesUsersUserIdRoute: AuthPreferencesUsersUserIdRoute,
    AuthPreferencesUsersNewRoute: AuthPreferencesUsersNewRoute,
    AuthPreferencesUsersIndexRoute: AuthPreferencesUsersIndexRoute,
  }

const AuthPreferencesUsersRouteRouteWithChildren =
  AuthPreferencesUsersRouteRoute._addFileChildren(
    AuthPreferencesUsersRouteRouteChildren,
  )

interface AuthPreferencesRouteRouteChildren {
  AuthPreferencesDashboardsRouteRoute: typeof AuthPreferencesDashboardsRouteRouteWithChildren
  AuthPreferencesEntityTypesRouteRoute: typeof AuthPreferencesEntityTypesRouteRouteWithChildren
  AuthPreferencesNavigationBarRouteRoute: typeof AuthPreferencesNavigationBarRouteRouteWithChildren
  AuthPreferencesRolesRouteRoute: typeof AuthPreferencesRolesRouteRouteWithChildren
  AuthPreferencesUsersRouteRoute: typeof AuthPreferencesUsersRouteRouteWithChildren
  AuthPreferencesConditionalRoute: typeof AuthPreferencesConditionalRoute
  AuthPreferencesDatasheetsRoute: typeof AuthPreferencesDatasheetsRoute
  AuthPreferencesDocumentsRoute: typeof AuthPreferencesDocumentsRoute
  AuthPreferencesFieldPermissionsRoute: typeof AuthPreferencesFieldPermissionsRoute
  AuthPreferencesGlobalTablesRoute: typeof AuthPreferencesGlobalTablesRoute
  AuthPreferencesGroupsRoute: typeof AuthPreferencesGroupsRoute
  AuthPreferencesHomepageDashboardRoute: typeof AuthPreferencesHomepageDashboardRoute
  AuthPreferencesInsightsDashboardRoute: typeof AuthPreferencesInsightsDashboardRoute
  AuthPreferencesManagementRoute: typeof AuthPreferencesManagementRoute
  AuthPreferencesMenuDesignerRoute: typeof AuthPreferencesMenuDesignerRoute
  AuthPreferencesModelRoute: typeof AuthPreferencesModelRoute
  AuthPreferencesModelSettingRoute: typeof AuthPreferencesModelSettingRoute
  AuthPreferencesOauthAdminRoute: typeof AuthPreferencesOauthAdminRoute
  AuthPreferencesOrganizationRoute: typeof AuthPreferencesOrganizationRoute
  AuthPreferencesRecycleRoute: typeof AuthPreferencesRecycleRoute
  AuthPreferencesSummaryDashboardRoute: typeof AuthPreferencesSummaryDashboardRoute
  AuthPreferencesSummaryDashboardSettingsRoute: typeof AuthPreferencesSummaryDashboardSettingsRoute
  AuthPreferencesTeamsRoute: typeof AuthPreferencesTeamsRoute
  AuthPreferencesIndexRoute: typeof AuthPreferencesIndexRoute
}

const AuthPreferencesRouteRouteChildren: AuthPreferencesRouteRouteChildren = {
  AuthPreferencesDashboardsRouteRoute:
    AuthPreferencesDashboardsRouteRouteWithChildren,
  AuthPreferencesEntityTypesRouteRoute:
    AuthPreferencesEntityTypesRouteRouteWithChildren,
  AuthPreferencesNavigationBarRouteRoute:
    AuthPreferencesNavigationBarRouteRouteWithChildren,
  AuthPreferencesRolesRouteRoute: AuthPreferencesRolesRouteRouteWithChildren,
  AuthPreferencesUsersRouteRoute: AuthPreferencesUsersRouteRouteWithChildren,
  AuthPreferencesConditionalRoute: AuthPreferencesConditionalRoute,
  AuthPreferencesDatasheetsRoute: AuthPreferencesDatasheetsRoute,
  AuthPreferencesDocumentsRoute: AuthPreferencesDocumentsRoute,
  AuthPreferencesFieldPermissionsRoute: AuthPreferencesFieldPermissionsRoute,
  AuthPreferencesGlobalTablesRoute: AuthPreferencesGlobalTablesRoute,
  AuthPreferencesGroupsRoute: AuthPreferencesGroupsRoute,
  AuthPreferencesHomepageDashboardRoute: AuthPreferencesHomepageDashboardRoute,
  AuthPreferencesInsightsDashboardRoute: AuthPreferencesInsightsDashboardRoute,
  AuthPreferencesManagementRoute: AuthPreferencesManagementRoute,
  AuthPreferencesMenuDesignerRoute: AuthPreferencesMenuDesignerRoute,
  AuthPreferencesModelRoute: AuthPreferencesModelRoute,
  AuthPreferencesModelSettingRoute: AuthPreferencesModelSettingRoute,
  AuthPreferencesOauthAdminRoute: AuthPreferencesOauthAdminRoute,
  AuthPreferencesOrganizationRoute: AuthPreferencesOrganizationRoute,
  AuthPreferencesRecycleRoute: AuthPreferencesRecycleRoute,
  AuthPreferencesSummaryDashboardRoute: AuthPreferencesSummaryDashboardRoute,
  AuthPreferencesSummaryDashboardSettingsRoute:
    AuthPreferencesSummaryDashboardSettingsRoute,
  AuthPreferencesTeamsRoute: AuthPreferencesTeamsRoute,
  AuthPreferencesIndexRoute: AuthPreferencesIndexRoute,
}

const AuthPreferencesRouteRouteWithChildren =
  AuthPreferencesRouteRoute._addFileChildren(AuthPreferencesRouteRouteChildren)

interface AuthTerminalConnectRouteRouteChildren {
  AuthTerminalConnectEmbedRoute: typeof AuthTerminalConnectEmbedRoute
  AuthTerminalConnectIndexRoute: typeof AuthTerminalConnectIndexRoute
}

const AuthTerminalConnectRouteRouteChildren: AuthTerminalConnectRouteRouteChildren =
  {
    AuthTerminalConnectEmbedRoute: AuthTerminalConnectEmbedRoute,
    AuthTerminalConnectIndexRoute: AuthTerminalConnectIndexRoute,
  }

const AuthTerminalConnectRouteRouteWithChildren =
  AuthTerminalConnectRouteRoute._addFileChildren(
    AuthTerminalConnectRouteRouteChildren,
  )

interface AuthCardRouteChildren {
  AuthCardFilterRoute: typeof AuthCardFilterRoute
}

const AuthCardRouteChildren: AuthCardRouteChildren = {
  AuthCardFilterRoute: AuthCardFilterRoute,
}

const AuthCardRouteWithChildren = AuthCardRoute._addFileChildren(
  AuthCardRouteChildren,
)

interface AuthEntityEntityIdBreadcrumbsRouteRouteChildren {
  AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute: typeof AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute
  AuthEntityEntityIdBreadcrumbsCalculationLogRoute: typeof AuthEntityEntityIdBreadcrumbsCalculationLogRoute
  AuthEntityEntityIdBreadcrumbsDetailsRoute: typeof AuthEntityEntityIdBreadcrumbsDetailsRoute
  AuthEntityEntityIdBreadcrumbsExplorationRoute: typeof AuthEntityEntityIdBreadcrumbsExplorationRoute
  AuthEntityEntityIdBreadcrumbsLinksRoute: typeof AuthEntityEntityIdBreadcrumbsLinksRoute
  AuthEntityEntityIdBreadcrumbsModelsRoute: typeof AuthEntityEntityIdBreadcrumbsModelsRoute
  AuthEntityEntityIdBreadcrumbsNotesRoute: typeof AuthEntityEntityIdBreadcrumbsNotesRoute
  AuthEntityEntityIdBreadcrumbsRelationshipsRoute: typeof AuthEntityEntityIdBreadcrumbsRelationshipsRoute
  AuthEntityEntityIdBreadcrumbsSummaryRoute: typeof AuthEntityEntityIdBreadcrumbsSummaryRoute
}

const AuthEntityEntityIdBreadcrumbsRouteRouteChildren: AuthEntityEntityIdBreadcrumbsRouteRouteChildren =
  {
    AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute:
      AuthEntityEntityIdBreadcrumbsSubEntityCodeRoute,
    AuthEntityEntityIdBreadcrumbsCalculationLogRoute:
      AuthEntityEntityIdBreadcrumbsCalculationLogRoute,
    AuthEntityEntityIdBreadcrumbsDetailsRoute:
      AuthEntityEntityIdBreadcrumbsDetailsRoute,
    AuthEntityEntityIdBreadcrumbsExplorationRoute:
      AuthEntityEntityIdBreadcrumbsExplorationRoute,
    AuthEntityEntityIdBreadcrumbsLinksRoute:
      AuthEntityEntityIdBreadcrumbsLinksRoute,
    AuthEntityEntityIdBreadcrumbsModelsRoute:
      AuthEntityEntityIdBreadcrumbsModelsRoute,
    AuthEntityEntityIdBreadcrumbsNotesRoute:
      AuthEntityEntityIdBreadcrumbsNotesRoute,
    AuthEntityEntityIdBreadcrumbsRelationshipsRoute:
      AuthEntityEntityIdBreadcrumbsRelationshipsRoute,
    AuthEntityEntityIdBreadcrumbsSummaryRoute:
      AuthEntityEntityIdBreadcrumbsSummaryRoute,
  }

const AuthEntityEntityIdBreadcrumbsRouteRouteWithChildren =
  AuthEntityEntityIdBreadcrumbsRouteRoute._addFileChildren(
    AuthEntityEntityIdBreadcrumbsRouteRouteChildren,
  )

interface AuthEntityEntityIdRouteRouteChildren {
  AuthEntityEntityIdBreadcrumbsRouteRoute: typeof AuthEntityEntityIdBreadcrumbsRouteRouteWithChildren
  AuthEntityEntityIdIndexRoute: typeof AuthEntityEntityIdIndexRoute
}

const AuthEntityEntityIdRouteRouteChildren: AuthEntityEntityIdRouteRouteChildren =
  {
    AuthEntityEntityIdBreadcrumbsRouteRoute:
      AuthEntityEntityIdBreadcrumbsRouteRouteWithChildren,
    AuthEntityEntityIdIndexRoute: AuthEntityEntityIdIndexRoute,
  }

const AuthEntityEntityIdRouteRouteWithChildren =
  AuthEntityEntityIdRouteRoute._addFileChildren(
    AuthEntityEntityIdRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthPreferencesRouteRoute: typeof AuthPreferencesRouteRouteWithChildren
  AuthTerminalConnectRouteRoute: typeof AuthTerminalConnectRouteRouteWithChildren
  Auth403Route: typeof Auth403Route
  Auth404Route: typeof Auth404Route
  AuthCalcstatusRoute: typeof AuthCalcstatusRoute
  AuthCardRoute: typeof AuthCardRouteWithChildren
  AuthComponentsRoute: typeof AuthComponentsRoute
  AuthDesignerRoute: typeof AuthDesignerRoute
  AuthGridRoute: typeof AuthGridRoute
  AuthHostRoute: typeof AuthHostRoute
  AuthProfileRoute: typeof AuthProfileRoute
  AuthReportsRoute: typeof AuthReportsRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthEntityEntityIdRouteRoute: typeof AuthEntityEntityIdRouteRouteWithChildren
  AuthEntityNewRoute: typeof AuthEntityNewRoute
  AuthInsightsDashboardIdRoute: typeof AuthInsightsDashboardIdRoute
  AuthInsightsDashboardsRoute: typeof AuthInsightsDashboardsRoute
  AuthInsightsReportsRoute: typeof AuthInsightsReportsRoute
  AuthIntegrationsSplatRoute: typeof AuthIntegrationsSplatRoute
  AuthEmbeddedDashboardAdminPowerbiReportIdRoute: typeof AuthEmbeddedDashboardAdminPowerbiReportIdRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthPreferencesRouteRoute: AuthPreferencesRouteRouteWithChildren,
  AuthTerminalConnectRouteRoute: AuthTerminalConnectRouteRouteWithChildren,
  Auth403Route: Auth403Route,
  Auth404Route: Auth404Route,
  AuthCalcstatusRoute: AuthCalcstatusRoute,
  AuthCardRoute: AuthCardRouteWithChildren,
  AuthComponentsRoute: AuthComponentsRoute,
  AuthDesignerRoute: AuthDesignerRoute,
  AuthGridRoute: AuthGridRoute,
  AuthHostRoute: AuthHostRoute,
  AuthProfileRoute: AuthProfileRoute,
  AuthReportsRoute: AuthReportsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthEntityEntityIdRouteRoute: AuthEntityEntityIdRouteRouteWithChildren,
  AuthEntityNewRoute: AuthEntityNewRoute,
  AuthInsightsDashboardIdRoute: AuthInsightsDashboardIdRoute,
  AuthInsightsDashboardsRoute: AuthInsightsDashboardsRoute,
  AuthInsightsReportsRoute: AuthInsightsReportsRoute,
  AuthIntegrationsSplatRoute: AuthIntegrationsSplatRoute,
  AuthEmbeddedDashboardAdminPowerbiReportIdRoute:
    AuthEmbeddedDashboardAdminPowerbiReportIdRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LegacyCreateRoute: LegacyCreateRoute,
  LegacyDashboardsRoute: LegacyDashboardsRoute,
  LegacyHomeRoute: LegacyHomeRoute,
  LoginContinueLogoutRoute: LoginContinueLogoutRoute,
  LoginLoginRoute: LoginLoginRoute,
  LoginResumeRoute: LoginResumeRoute,
  LoginInactiveRoute: LoginInactiveRoute,
  LoginLicenseLimitRoute: LoginLicenseLimitRoute,
  LoginOrganizationBusyRoute: LoginOrganizationBusyRoute,
  LegacyEntitiesSplatRoute: LegacyEntitiesSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
